export default __webpack_public_path__ + "static/media/35t.26c954c0.jpg";